// import React from 'react'

const BlogData = [
      {
        id: 1,
        image:
          "https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_400/https://www.eastasiaforum.org/wp-content/uploads/2021/07/2018-04-05T165026Z_1101404031_RC18839E3160_RTRMADP_3_USA-MILITARY-400x267.jpg",
        title: "Space Commands Lt. Gen John Shaw Says Space Is Under Threat",
        about:
          "In an exclusive interview, the military branch second in command talks about junk in orbit, cyberattacks, satellite vulnerabilities, and Russia's war in Ukraine.",
      },
      {
        id: 2,
        image:
          "https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_400/https://www.eastasiaforum.org/wp-content/uploads/2021/07/2018-04-05T165026Z_1101404031_RC18839E3160_RTRMADP_3_USA-MILITARY-400x267.jpg",
        title: "Space Commands Lt. Gen John Shaw Says Space Is Under Threat",
        about:
          "In an exclusive interview, the military branch second in command talks about junk in orbit, cyberattacks, satellite vulnerabilities, and Russia's war in Ukraine.",
      },
      {
        id: 3,
        image:
          "https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_400/https://www.eastasiaforum.org/wp-content/uploads/2021/07/2018-04-05T165026Z_1101404031_RC18839E3160_RTRMADP_3_USA-MILITARY-400x267.jpg",
        title: "Space Commands Lt. Gen John Shaw Says Space Is Under Threat",
        about:
          "In an exclusive interview, the military branch second in command talks about junk in orbit, cyberattacks, satellite vulnerabilities, and Russia's war in Ukraine.",
      },
      {
        id: 4,
        image:
          "https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img,w_400/https://www.eastasiaforum.org/wp-content/uploads/2021/07/2018-04-05T165026Z_1101404031_RC18839E3160_RTRMADP_3_USA-MILITARY-400x267.jpg",
        title: "Space Commands Lt. Gen John Shaw Says Space Is Under Threat",
        about:
          "In an exclusive interview, the military branch second in command talks about junk in orbit, cyberattacks, satellite vulnerabilities, and Russia's war in Ukraine.",
      },
    ];

    export default BlogData;